import { ReadingText } from "./type.app.js";

/** Isolated letter-combination prompts the teacher may not know how to say out of context. */
const LETTER_COMBO_HINTS: Record<string, string> = {
  qu: "'qu' says /kw/ as in 'queen'",
  ck: "'ck' says /k/ as in 'duck'",
  ff: "'ff' says /f/ as in 'off'",
  ll: "'ll' says /l/ as in 'bell'",
  ss: "'ss' says /s/ as in 'miss'",
  zz: "'zz' says /z/ as in 'buzz'",
  sh: "'sh' says /sh/ as in 'ship'",
  ch: "'ch' says /ch/ as in 'chin'",
  th: "'th' says /th/ as in 'thumb'",
  wh: "'wh' says /w/ as in 'when'",
  ph: "'ph' says /f/ as in 'phone'",
  ng: "'ng' says /ng/ as in 'ring'",
  nk: "'nk' says /nk/ as in 'pink'",
  tch: "'tch' says /ch/ as in 'catch'",
  bl: "'bl' says /bl/ as in 'blue'",
  cl: "'cl' says /cl/ as in 'clap'",
  fl: "'fl' says /fl/ as in 'flag'",
  gl: "'gl' says /gl/ as in 'glad'",
  pl: "'pl' says /pl/ as in 'play'",
  sl: "'sl' says /sl/ as in 'sled'",
  sc: "'sc' says /sc/ as in 'scan'",
  sk: "'sk' says /sk/ as in 'skip'",
  sm: "'sm' says /sm/ as in 'smog'",
  sn: "'sn' says /sn/ as in 'snap'",
  br: "'br' says /br/ as in 'brown'",
  cr: "'cr' says /cr/ as in 'crab'",
  dr: "'dr' says /dr/ as in 'drum'",
  fr: "'fr' says /fr/ as in 'frog'",
  gr: "'gr' says /gr/ as in 'green'",
  pr: "'pr' says /pr/ as in 'pram'",
  tr: "'tr' says /tr/ as in 'tree'",
  tw: "'tw' says /tw/ as in 'twin'",
  sw: "'sw' says /sw/ as in 'swim'",
  st: "'st' says /st/ as in 'stop'",
  sp: "'sp' says /sp/ as in 'spin'",
  str: "'str' says /str/ as in 'strap'",
  spr: "'spr' says /spr/ as in 'spring'",
  spl: "'spl' says /spl/ as in 'split'",
  scr: "'scr' says /scr/ as in 'scrap'",
  shr: "'shr' says /shr/ as in 'shrimp'",
  thr: "'thr' says /thr/ as in 'three'",
  squ: "'squ' says /skw/ as in 'squid'",
  nd: "'nd' says /nd/ as in 'and'",
  nt: "'nt' says /nt/ as in 'ant'",
  ai: "'ai' says /A/ as in 'rain'",
  ay: "'ay' says /A/ as in 'day'",
  ee: "'ee' says /E/ as in 'tree'",
  ea: "'ea' usually says /E/ as in 'eat'",
  oa: "'oa' says /O/ as in 'boat'",
  ow: "'ow' can say /O/ as in 'snow' or /ow/ as in 'cow'",
  oe: "'oe' says /O/ as in 'toe'",
  ie: "'ie' says /I/ as in 'pie'",
  igh: "'igh' says /I/ as in 'night'",
  ue: "'ue' says /oo/ as in 'blue'",
  ew: "'ew' says /oo/ as in 'new'",
  oo: "'oo' can say /oo/ as in 'moon' or /u/ as in 'book'",
  ou: "'ou' usually says /ow/ as in 'owl'",
  oi: "'oi' says /oy/ as in 'oil'",
  oy: "'oy' says /oy/ as in 'boy'",
  au: "'au' says /aw/ as in 'auto'",
  aw: "'aw' says /aw/ as in 'saw'",
  ui: "'ui' says /oo/ as in 'fruit'",
  ey: "'ey' usually says /A/ as in 'they'",
  eigh: "'eigh' says /A/ as in 'eight'",
  ar: "'ar' says /ar/ as in 'car'",
  or: "'or' says /or/ as in 'for'",
  er: "'er' says /er/ as in 'her'",
  ir: "'ir' says /er/ as in 'bird'",
  ur: "'ur' says /er/ as in 'hurt'",
  air: "'air' says /air/ as in 'hair'",
  ear: "'ear' says /ear/ as in 'ear'",
  ore: "'ore' says /or/ as in 'more'",
  ure: "'ure' says /ur/ as in 'sure'",
  oor: "'oor' says /or/ as in 'door'",
};

export const LETTER_COMBOS_LONGEST_FIRST = Object.keys(LETTER_COMBO_HINTS).sort((left, right) => {
  const byLength = right.length - left.length;
  return byLength !== 0 ? byLength : left.localeCompare(right);
});

export const teachingHintFor = (text: ReadingText): string | null => {
  if (text.kind !== "letter") return null;
  const lower = text.text.trim().toLowerCase();
  return LETTER_COMBO_HINTS[lower] ?? null;
};
